import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { closeAllModal, showNestedModal } from "../../../features/modal/modalSlice"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useEffect, useState } from "react";
import Btn from "../../shared/button/Btn";
import { useScrollLock } from "../../../hooks/useScrollLock";
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 30px;
            min-height: 400px;

            .photo-section-container{
                display: flex;
                align-items: center;
                
                img{
                    width: 500px;
                    height: auto;
                    max-height: 750px;
                    margin-bottom: 20px;
                    border-radius: 10px;
                }

                .arr-icon{
                    font-size: 3rem;
                    color: ${({theme}) => theme.mainTextColor};
                    cursor: pointer;
                }

            }

            .dot-container{
                display: flex;
                gap: 5px;

                .dot-item{
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    cursor: pointer;
                    background-color: ${({theme}) => theme.mainTextColor};
                }

                .active{
                    background-color: var(--color-main);
                }
            }
        }

    }

`
    
const LoadOwnerImageModal = () => {

    const {photoList, currentPhotoItemId} = useSelector(state => state.loadOwner)
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(closeAllModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const [currentPhotoItem, setCurrentPhotoItem] = useState(photoList[currentPhotoItemId -1])

    const handleChangePhoto = ({type}) => {
        if(type === "forward"){
            const current = currentPhotoItem.id === photoList.length ? photoList[0] : photoList.find(item => item.id === currentPhotoItem.id + 1)
            setCurrentPhotoItem(current)
        }

        if(type === "back"){
            const current = currentPhotoItem.id < 1 ? photoList[photoList.length -1] : photoList.find(item => item.id === currentPhotoItem.id - 1)
            setCurrentPhotoItem(current)
        }
    }


    const handleDotClick = (item) => {
        setCurrentPhotoItem(item)
    }
    

    if(photoList.length < 1) {
        return null
    }

  return (
    <Container onClick={()=> dispatch(showNestedModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <div className="content">
                <div className="photo-section-container">
                    <MdKeyboardArrowLeft className="arr-icon" onClick={(() =>handleChangePhoto({type: "back"}))}/>
                    <div className="img-container">
                        <img src={currentPhotoItem?.photo} alt="" />
                    </div>
                    <MdKeyboardArrowRight className="arr-icon" onClick={(() =>handleChangePhoto({type: "forward"}))}/>
                </div>
                <div className="dot-container">
                    {
                        photoList.map(item => (
                            <div key={item.id} className={item.id === currentPhotoItem.id ? "active dot-item" : "dot-item"} onClick={() => handleDotClick(item)}/>
                        ))
                    }
                </div>
            </div>
            <Btn bgColor="#E85446" color="#fff" width={"220px"} handleClick={()=> dispatch(showNestedModal(null))}>Geri Dön</Btn>
        </div>
    </Container>
  )
}
 
export default LoadOwnerImageModal